// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__3B0KF","Question":"ActiveQuiz_Question__2s3Ew"};